import {useState} from "react";
import {useKeycloakFunctions} from "./useKeycloakFunctions";
import {customerProductsAPI} from "../common/api/customerProductsAPI";
import {API_LOYALTY_PROGRAM} from "../common/api/apiConstants";
import {createURLQueryFromParams} from "../common/api/apiUtil";

export const useLoyaltyPoints = () => {

    const {initialized, authenticated} = useKeycloakFunctions();

    const [loyaltyPoints, setLoyaltyPoints] = useState();
    const [loadingLoyaltyPoints, setLoadingLoyaltyPoints] = useState(false);
    const [errorLoyaltyPoints, setErrorLoyaltyPoints] = useState(false);

    const getLoyaltyPoints = (hapimag_member_id) => {
        if (initialized && authenticated) {
            setLoadingLoyaltyPoints(true);
            setErrorLoyaltyPoints(null);

            const params = {};
            if (hapimag_member_id) {
                params.hapimag_member_id = hapimag_member_id;
            }

            customerProductsAPI.get(API_LOYALTY_PROGRAM + createURLQueryFromParams(params))
                .then(res => res.data)
                .then(response => {
                    setLoadingLoyaltyPoints(false);
                    setLoyaltyPoints(response);
                })
                .catch(err => {
                    setLoadingLoyaltyPoints(false);
                    setErrorLoyaltyPoints(err);
                });
        }
    };

    return {
        getLoyaltyPoints,
        loyaltyPoints,
        loadingLoyaltyPoints,
        errorLoyaltyPoints
    };
};
